<template>
  <div id="emailEvents">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              Property Analytics
            </div>
            <div class="row d-block">
              <property-analytics />
            </div>
          </section>
          <div class="clearfix" />
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>

<script>
import templateForm from './form/index.vue';

export default {
    data() {
        return {
            adding: false
        };
    },
    components: {
        'property-analytics': templateForm
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/clientanalytics/property/index.vue